<template>
    <div class="variant">
        <visual :src="images.visual" />
        <heading :level="3" v-html="variant.title" />
        <paragraph size="L" v-html="variant.text" />
    </div>
</template>

<script>
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Visual from 'gvue/src/core/Visual'

import { getVisual } from '@/helpers/visual'

export default {
    name: 'DispenserVariant',
    components: {
        Heading,
        Paragraph,
        Visual
    },
    props: {
        variant: {
            type: Object,
            required: true
        }
    },
    computed: {
        images () {
            return { visual: getVisual(this.variant.visual) }
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.variant
    margin-top: ($gap * 3)

.caption
    display: flex
    flex-direction: column
    align-items: center

.g
    .g_h3
        margin: ($gap * 1.75) 0 0

    .g_txt_L
        margin: ($gap * 1.25) 0 0

    .g_visual
        height: auto
        width: pxToRem(270)

+desktop
    .variant
        margin-top: ($gap * 6)
</style>
